// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__101mW","label":"Labeled_label__3N7J5","divider":"Labeled_divider__3T2dt"};